"use client";

/**
 * Montado UNA vez en el layout raíz (`src/app/[locale]/layout.tsx`). No
 * renderiza nada — dispara efectos de arranque que sólo importan dentro del
 * shell nativo:
 *
 *  - Registro de push notifications (ver `push.ts`). En web es un no-op
 *    (`isNativePlatform()` da `false`), así que este componente no cambia NADA
 *    del comportamiento de la PWA en navegador ni de los tests (unit/e2e
 *    corren siempre contra un navegador normal, nunca dentro del shell
 *    Capacitor → `isNativePlatform()` es `false` en esos entornos).
 *
 * Deliberadamente NO se lee la sesión acá (ni en el layout que lo monta): el
 * endpoint `/api/native/push-token` resuelve el usuario del lado server con la
 * cookie de sesión ya existente. Si montáramos esto leyendo `getSessionUser()`
 * en el Server Component del layout raíz, CADA página de la app (incluida la
 * landing pública) dejaría de poder pre-renderizarse estáticamente (leer
 * cookies fuerza rendering dinámico) — efecto colateral que no vale la pena
 * para un registro de push que puede resolverse enteramente del lado cliente.
 */
import { useEffect, useRef } from "react";
import { bootstrapPushNotifications } from "./push";

export function NativeBootstrapClient() {
  const ranOnce = useRef(false);

  useEffect(() => {
    if (ranOnce.current) return;
    ranOnce.current = true;
    void bootstrapPushNotifications();
  }, []);

  return null;
}
